<template lang="html">
    <entity-page id="user" v-bind:loading="progress">
        <template slot="header-left">
            <div class="row" v-if="isUserAdmin">
                <z-button accent v-on:click="block"   v-if="!isBlocked" fitContent>Заблокировать</z-button>
                <z-button accent v-on:click="unblock" v-if="isBlocked"  fitContent>Разблокировать</z-button>
                <z-button accent v-on:click="authoff" v-if="!isAuthOff" fitContent>Сбросить авторизацию</z-button>
            </div>
        </template>
        <template slot="header-center"></template>
        <template slot="header-right">
            <z-icon-button v-bind:icon="['fa', 'xmark']" danger-light  rounded v-on:click="back"></z-icon-button>
            <z-icon-button v-bind:icon="['fa', 'check']" success-light rounded v-on:click="save"></z-icon-button>
        </template>
        <div slot="default">
            <z-input 
                name="fio" id="fio" label="ФИО"
                v-model="user.fio" v-bind:required="true"
                v-bind:error="errors.first('fio')" v-validate="{required: true}" data-vv-as=" "
            ></z-input>
            <div class="row">
                <z-input
                    class="col-6" name="login" id="login" label="Логин"
                    v-model="user.login" v-on:blur="setEmail" v-bind:required="true"
                    v-bind:error="errors.first('login')" v-validate="{required: true, alpha_dash: true}" data-vv-as=" "
                ></z-input>
                <z-input 
                    class="col-6" name="email" id="email" label="Email"
                    v-model="user.email" v-on:blur="setEmail" v-bind:required="true"
                    v-bind:error="errors.first('email')" v-validate="{required: true, email: true}" data-vv-as=" "
                ></z-input>
            </div>

            <multy-autocomplete
                id="groups" name="groups" placeholder="Группа" label="Группа"
                display-property="name" property="id" return="id"
                v-model="user.groups" v-bind:items="usersGroups"
                v-bind:showOnFocus="true" v-bind:show-search-input="false"
            ></multy-autocomplete>

            <div class="avatar-container" v-if="user && user.id">
                <div class="avatar" v-if="user.avatar">
                    <img v-bind:src="$root.staticEndpoint + user.avatar"/>
                </div>
                <z-input-image 
                    v-bind:imgHeightMin='60' v-bind:imgWidthMin='60'
                    v-bind:imgHeightMax='300' v-bind:imgWidthMax='300'
                    name="avatar" placeholder="Аватар" label="Аватар" buttonText="Загрузить аватар" width="200px"
                    v-bind:show-label="false" v-bind:link="($root.endpoint + '/user/' + user.id + '/avatar/save')"
                    v-on:complete="getUser"
                ></z-input-image>
            </div>

            <toggle-card heading="Изменение пароля">
                <div class="row">
                    <z-input 
                        class="col-6" name="password" id="password" label="Пароль"
                        v-model="user.password" v-bind:required="true" type="password"
                        v-bind:error="errors.first('password')" v-validate="{required: !user.id}" data-vv-as=" "
                    ></z-input>
                    <z-input 
                        class="col-6" name="password_confirm" id="password_confirm" label="Подтверждение пароля"
                        v-model="user.password_confirm" v-bind:required="true" type="password"
                        v-bind:error="errors.first('password_confirm')" v-validate="{required: !!user.password}" data-vv-as=" "
                    ></z-input>
                </div>

                <z-check 
                    v-if="user.email && (user.email.indexOf('@')+1)" 
                    id="send_email" name="send_email" label="Отправить пользователю пароль на Email"
                    v-model="user.send_email" v-bind:value="true"
                ></z-check>
            </toggle-card>
        </div>
    </entity-page>
</template>
<script>
    import ZInput      from '@/components/ZInput';
    import ZCheck      from '@/components/ZCheck';
    import ZCheckList  from '@/components/ZCheckList';
    import ZInputImage from '@/components/ZInputImage';
    import ToggleCard  from '@/components/ToggleCard';
    import Properties  from '@/components/Properties'
    import EntityPage  from '@/components/EntityPage.vue';
    import ZIconButton from '@/components/ZIconButton.vue';
    import ZButton     from '@/components/ZButton.vue';
    import MultyAutocomplete  from '@/components/MultyAutocomplete';
    import ZInputAutocomplete from '@/components/ZInputAutocomplete';
    export default {
        components: {Properties, ZButton, ZInput, ZCheck, ZCheckList, ZInputImage, ToggleCard, MultyAutocomplete, ZIconButton, EntityPage, ZInputAutocomplete},
        data() {
            return {
                baseDomain: '',
                user: {
                    login: '',
                    email: '',
                    sort: 100,
                    password: '',
                    password_confirm: '',
                    groups: [],
                    send_email: false,
                    is_blocked: false,
                    is_breakauth: false
                }
            }
        },
        computed: {
            /**
             * Флаг загрузки текущего компонента
             */
            progress() {
                return this.progressObj['load-user-card'];
            },
            /**
             * Объект с флагами загрузи
             */
            progressObj() {
                return this.$store.state.progressObj;
            },
            /**
             * Список групп пользователей
             */
            usersGroups() { //все групппы пользователей
                return this.$store.state.users.groups;
            },
            /**
             * Получения id пользователя
             */
            userId() {
                return this.$route.params.user_id;
            },

            currentUser() {
                return this.$store.state.users.current;
            },
            isUserAdmin() {
                return (this.currentUser && this.currentUser.groups_codes) ? !!(this.currentUser.groups_codes.indexOf('administrators')+1) : false;
            },
            isBlocked() {
                return !!parseInt(this.user.is_blocked);
            },
            isAuthOff() {
                return !!parseInt(this.user.is_breakauth);
            }
        },
        watch: {
            '$route.params.user_id'() {
                this.$store.commit('openRightPanel');
                this.getUser();
            }
        },
        created() {
            this.$root.$on('update-user-form', (id) => {
                if (parseInt(id) == parseInt(this.userId)) this.init();
            });
            this.$store.commit('openRightPanel');
            this.init();
            this.getUserGroups();
            this.getBaseDomain();
        },
        methods: {
            /**
             * Инициализация компонента
             */
            init() {
                this.getUser();
            },
            /**
             * Возвращает пользователя на предыдущую страницу
             * Обрабочик события click, на кнопке "Закрыть"
             */
            back() {
                this.$router.push({name: 'Users', query: this.$route.query});
            },
            /**
             * Получение пользователя по id
             */
            getUser() {
                if (this.userId !== 'new') {
                    this.$store.commit('showProgressBar', 'load-user-card');
                    this.$store.dispatch('users/getUser', this.userId).then(r => {
                        if (!r) return;
                        this.user = Object.assign({}, r);
                        this.user.password = '';
                    }).finally(() => this.$store.commit('hideProgressBar', 'load-user-card'))
                }
            },
            /**
             * Сохранение пользователя
             */
            save() {
                this.$validator.validateAll().then(valid => {
                    if (!valid) return;
                    let user = Object.assign({}, this.user);
                    user.groups = user.groups.map(g => g.id);
                    if (this.userId && this.userId != 'new') this.putUser(user);
                    else this.postUser(user);
                });
            },
            /**
             * Добавление пользователя
             */
            postUser(user) {
                this.$store.commit('showProgressBar', 'load-user-card');
                this.$store.dispatch('users/postUser', user).then(user => {
                    if (!user) return;
                    this.$router.push({name: 'User', params: {user_id: user.id}});
                    this.$root.$emit('reload-table', 'users');
                }).finally(() => this.$store.commit('hideProgressBar', 'load-user-card'));
            },
            /**
             * Изменение пользователя
             */
            putUser(user) {
                this.$store.commit('showProgressBar', 'load-user-card');
                this.$store.dispatch('users/putUser', user).then(() => {
                    this.init();
                    this.$root.$emit('reload-table', 'users');
                }).finally(() => this.$store.commit('hideProgressBar', 'load-user-card'));    
            },
            /**
             * Получение всех групп пользователей
             */
            getUserGroups() {
                this.$store.commit('showProgressBar', 'load-user-card');
                this.$store.dispatch('users/getUsersGroups', {count: 'all', page: 1})
                    .finally(() => this.$store.commit('hideProgressBar', 'load-user-card'));
            },
            /**
             * Получение домена 
             */
            getBaseDomain() {
                this.$store.dispatch('module/getOneModulePropertyValue', {
                    module_name: 'module',
                    prop_name: 'company_domain'
                }).then(r => {if (r && r.value) this.baseDomain = r.value;})
            },
            /**
             * Создает почту для пользователя исходя из его логина
             */
            setEmail() {
                if (!(this.user.email.indexOf('@')+1)) this.user.email = this.user.login + '@' + this.baseDomain;
            },
            block() {
                this.$root.$emit('z-alert', 'Вы уверены в блокировке пользователя?', null, () => {
                    this.$store.commit('showProgressBar', 'load-user-card');
                    this.$store.dispatch('users/blockUser', this.userId).then(r => r ? this.getUser() : null)
                        .finally(() => this.$store.commit('hideProgressBar', 'load-user-card'));
                });
            },
            unblock() {
                this.$root.$emit('z-alert', 'Вы уверены в разблокировке пользователя?', null, () => {
                    this.$store.commit('showProgressBar', 'load-user-card');
                    this.$store.dispatch('users/unblockUser', this.userId).then(r => r ? this.getUser() : null)
                        .finally(() => this.$store.commit('hideProgressBar', 'load-user-card'));
                });
            },
            authoff() {
                this.$root.$emit('z-alert', 'Вы уверены в сбросе авторизации пользователя?', null, () => {
                    this.$store.commit('showProgressBar', 'load-user-card');
                    this.$store.dispatch('users/authoffUser', this.userId).then(r => r ? this.getUser() : null)
                        .finally(() => this.$store.commit('hideProgressBar', 'load-user-card'));
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// User.vue?62b45bbe